<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <template v-if="attendees.length > 0 && !loadingData">
      <v-row v-for="attendee in attendees" :key="attendee.id">
        <v-col
          cols="1"
          v-if="!enableEdit"
          class="align-self-center justify-end text-right"
        >
          <v-icon>
            {{ attendee.attended ? "mdi-account-check" : "mdi-account-cancel" }}
          </v-icon>
        </v-col>
        <v-col
          cols="1"
          v-if="enableEdit"
          class="d-flex pa-0 align-self-center justify-end text-right"
        >
          <v-checkbox
            v-model="attendee.attended"
            hide-details
            class="shrink mr-2 ma-0 attendee-checkbox"
          ></v-checkbox>
        </v-col>
        <v-col cols="4" class="text-left align-self-center justify-start">
          {{
            attendee.attributes.first_name + " " + attendee.attributes.last_name
          }}
        </v-col>
      </v-row>

      <v-row v-if="enableEdit">
        <v-col align="center">
          <v-divider></v-divider>
          <v-btn
            outlined
            elevation="0"
            class="rounded-xxl text-none mr-8 px-4 my-2"
            @click="enableEdit = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            data-testid="submit-button"
            type="submit"
            color="accent"
            class="rounded-xxl text-none white--text px-4 my-2 submit"
            @click="updateAttendees"
          >
            {{ $t("save") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-fab-transition v-if="!enableEdit">
        <v-btn
          right
          bottom
          fab
          large
          color="accent"
          style="position: fixed; bottom: 20px; right: 10px; z-index: 1"
          data-testid="edit-button"
          @click.stop="enableEdit = true"
          class="edit-activity-item-button"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>

    <v-row
      v-if="(!attendees || attendees.length == 0) && !loadingData"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
        offset-sm="2"
        offset-md="3"
        offset-lg="4"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptyAttendeesPageTitle')"
          :page-text="$t('emptyAttendeesPageText')"
          page-image="image1"
        />
      </v-col>
    </v-row>
  </nav>
</template>

<script>
import i18n from "../../plugins/i18n";
import EmptyPage from "../../components/EmptyPage";
import { getEventAttendees, updateAttendees } from "../../api/eventApi";
import AlertMessages from "../../components/AlertMessages";

export default {
  components: {
    EmptyPage,
    AlertMessages,
  },
  mixins: [],
  data() {
    return {
      attendees: [],
      link: {
        title: i18n.t("createEventTitle"),
        route: "/target-groups/create",
      },
      alertType: "",
      alertMsg: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      eventId: this.$route.params.id,
      loadingData: false,
      confirmationDialogTitle: "",
      confirmationDialogText: "",
      confirmationDialogCancelBtn: "",
      confirmationDialogSubmitBtn: "",
      dialogVisible: false,
      selectedTargetIdForDeletion: "",
      cancelLink: "",
      enableEdit: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path != null && from.path != "/redirect" && from.path != "/") {
      next((vm) => {
        (vm.cancelLink = from.path), (vm.previousRoute = from);
      });
    } else {
      next();
    }
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created() {
    this.loadingData = true;
    await this.fetchEventAttendees();
    this.loadingData = false;
  },
  methods: {
    async fetchEventAttendees() {
      try {
        const response = await getEventAttendees(this.eventId);
        if (response.status) {
          if (response.status == 200) {
            this.attendees = response.data.data;
            this.attendees.map((n) => {
              n.attended = response.data.meta.attendees.includes(parseInt(n.id))
                ? true
                : false;
            });
            this.attendees = [...this.attendees];
            window.scrollTo(0, 0);
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push("/not-exist");
          }
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    async updateAttendees() {
      if (this.attendees.length) {
        this.loading = true;
        try {
          let data = {
            data: {
              type: "event-attendees",
              attributes: {
                attendees: this.attendees
                  .filter((n) => n.attended)
                  .map((n) => n.id),
              },
            },
          };

          const response = await updateAttendees(this.$route.params.id, data);
          if (response.status == 200) {
            this.fetchEventAttendees();
            this.enableEdit = false;
            this.loading = false;
            this.alertValue = true;
            this.alertType = "success";
            this.alertMsg = i18n.t("updateAttendeesSuccessMsg");
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.v-messages.theme--light.primary--text {
  display: none;
}
</style>
